import { OfferRoutes } from './offer/offer.routing';
import { UserRoutes } from './user/user.routing';
import { VehicleInformationRoutes } from './vehicle-information/vehicle-information.routing';
import { ContractRoutes } from './contract/contract.routing';
import { ThankYouRoutes } from './thank-you/thank-you.routing';
import { WelcomeRoutes } from './welcome/welcome.routing';
import { ConfirmationRoutes } from './confirmation/confirmation.routing';
import { ErrorRoutes } from './error/error.routing';

export const NewQuotation = [
  ...WelcomeRoutes,
  ...VehicleInformationRoutes,
  ...UserRoutes,
  ...OfferRoutes,
  ...ContractRoutes,
  ...ConfirmationRoutes,
  ...ThankYouRoutes,
  ...ErrorRoutes,
];
